// extracted by mini-css-extract-plugin
export default {"tile-row":"_2umE0tI3bu","tileRow":"_2umE0tI3bu","tile-column":"vMvXXO3N2h","tileColumn":"vMvXXO3N2h","webhook-tile":"pHMY8TU56E","webhookTile":"pHMY8TU56E","name":"_2ecEuxqHCq","description":"_3LK51jll-g","logo":"_1JJPQSniuV"};
    if(module.hot) {
      // 1622798440935
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  